export var api = {
    token: {
        generate: '/wp-json/jwt-auth/v1/token',
    },
    jobs: {
        all: '/api/jobs',
        categories: '/api/jobs/categories',
    },
    musicalGenres: {
        all: '/api/musicalGenres',
        categories: '/api/musicalGenres/categories',
    },
    skills: {
        all: '/api/skills',
        categories: '/api/skills/categories',
    },
    account: {
        createProfessional: '/api/account/create/professional',
        createVisitor: '/api/account/create/visitor',
    },
    user: {
        check: '/api/user/check',
        update: '/api/user/update',
        get: '/api/user',
        delete: '/api/user/delete',
        emailUpdate: '/api/user/updateEmail',
        passwordUpdate: '/api/user/updatePassword',
    },
    experiences: {
        types: '/api/experiences/types',
    },
    categories: {
        all: '/api/categories',
    },
    identities: {
        all: '/api/identities',
    },
    professionalStatus: {
        all: '/api/professionalStatus',
    },
    search: {
        query: function (params) { return "/api/search".concat(params); },
    },
    password: {
        forgot: '/api/password/forgot',
        reset: '/api/password/reset',
    },
    help: {
        report: '/api/help/report',
    },
    bookmark: {
        get: '/api/bookmark',
        store: function (params) { return "/api/bookmark/store".concat(params); },
        delete: '/api/bookmark/delete',
    },
    favorites: {
        all: function (full) {
            if (full === void 0) { full = false; }
            return "/api/favorites?full=".concat(full ? '1' : '0');
        },
        one: function (id) { return "/api/favorites/".concat(id); },
        new: '/api/favorites/new',
        remove: '/api/favorites/remove',
        update: '/api/favorites/update',
        addProfile: '/api/favorites/addProfile',
        addBulkProfile: '/api/favorites/addBulkProfile',
        removeProfile: '/api/favorites/removeProfile',
        removeBulkProfile: '/api/favorites/removeBulkProfile',
    },
    content: {
        all: '/api/content',
    },
};
